<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:86%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>
        </mat-card-title>
        <mat-card-content fxLayout="column">
            <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start center center" style="margin-top:50px;">

                <div fxLayout="row" fxLayoutGap="20px" fxFlex="grow" ngStyle.md="width:90%" ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:100%">
                    <div fxFlexAlign="center">Γρήγορη Αναζήτηση</div>
                    <div fxFlexAlign="center" fxLayoutGap="20px">
                        <mat-form-field>
                            <mat-label>Κριτήριο Αναζήτησης</mat-label>
                            <mat-select [(ngModel)]="simpleSearchSelectedValue" (selectionChange)="criteriaChanged()">
                                <mat-option *ngFor="let searchField of studentSearchFields"
                                            [value]="searchField">{{searchField.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field *ngIf="simpleSearchSelectedValue && simpleSearchSelectedValue.type === 'text'">
                            <mat-label>Όνομα</mat-label>
                            <input matInput [(ngModel)]="searchValue" (keydown)="fastSearch($event) ">
                            <!--          <button mat-button matSuffix mat-icon-button aria-label="search" (click)="search()">-->
                            <!--            <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>-->
                            <!--          </button>-->
                        </mat-form-field>


                        <mat-form-field
                                *ngIf="simpleSearchSelectedValue && simpleSearchSelectedValue.type === 'select'">
                            <mat-label>{{simpleSearchSelectedValue.label}}</mat-label>
                            <mat-select [(ngModel)]="simpleSearchSelectedValue.value" multiple>
                                <mat-option *ngFor="let item of getSelectedValueOptions()"
                                            [value]="item">{{displayOptionValue(item)}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field *ngIf="simpleSearchSelectedValue && simpleSearchSelectedValue.type === 'date'">
                            <mat-label>Κριτήριο</mat-label>
                            <input readonly matInput [matDatepicker]="picker" [(ngModel)]="searchValue">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <span *ngIf="simpleSearchSelectedValue && simpleSearchSelectedValue.type === 'date'">μεταξύ</span>
                        <mat-form-field *ngIf="simpleSearchSelectedValue && simpleSearchSelectedValue.type === 'date'">
                            <mat-label>Κριτήριο</mat-label>
                            <input readonly matInput [matDatepicker]="picker1" [(ngModel)]="betweenDateValue">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>


                        <button mat-button matSuffix mat-icon-button aria-label="search" (click)="search()">
                            <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>
                        </button>

                    </div>

                    <mat-icon fxFlexAlign="center" (click)="showSearchDialog()" matTooltip="Σύνθετη αναζήτηση">
                        person_search
                    </mat-icon>


                    <div fxLayoutAlign.gt-sm="end center center" fxLayoutAlign.lt-md="center stretch"
                         fxFlex.lt-md="100">
                        <button ngStyle.lt-md="width:100%;"
                                style="background: var(--primary); color:white; font-weight: normal; vertical-align: middle; border-radius: 50px;"
                                mat-flat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
                            Ενέργειες
                            &nbsp;
                            <mat-icon style="vertical-align: middle; color:white;">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                        <mat-menu #menu="matMenu">
                            <mat-list class="menuList">
                                <mat-list-item class="menuList">
                                    <button mat-menu-item [disabled]="this.selection.selected.length === 0"
                                            (click)="initFormProc()">
                                        <mat-icon class="icon">description</mat-icon>&nbsp;Δημοσίευση δήλωσης
                                    </button>
                                </mat-list-item>
                            </mat-list>

                            <mat-list class="menuList">
                                <mat-list-item class="menuList">
                                    <button mat-menu-item [disabled]="this.selection.selected.length === 0"
                                            (click)="initSMS()">
                                        <mat-icon class="icon">sms</mat-icon>&nbsp;Αποστολή SMS σε χρήστες
                                    </button>
                                </mat-list-item>
                            </mat-list>

                            <!--          <mat-list class="menuList">-->
                            <!--            <button mat-menu-item  (click)="initFormProc()"  [disabled]="this.selection.selected.length === 0">-->
                            <!--              <mat-icon class="icon">notifications</mat-icon>&nbsp;Αποστολή υπενθύμισης-->
                            <!--            </button>-->
                            <!--          </mat-list>-->

                            <mat-list class="menuList">
                                <mat-list-item class="menuList">
                                    <button mat-menu-item (click)="exportToExcel()">
                                        <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε xlsx
                                    </button>
                                </mat-list-item>
                            </mat-list>
                            <!--            <mat-list class="menuList">-->
                            <!--            <mat-list-item class="menuList" >-->
                            <!--              <button mat-menu-item>-->
                            <!--                <mat-icon class="icon">email</mat-icon>&nbsp; Προσθήκη xlsx σε email-->
                            <!--              </button>-->
                            <!--            </mat-list-item>-->
                            <!--            </mat-list>-->

                            <mat-list class="menuList">
                                <mat-list-item class="menuList">
                                    <button mat-menu-item (click)="exportToPDF()">
                                        <mat-icon class="icon">picture_as_pdf</mat-icon>&nbsp;Εξαγωγή σε pdf
                                    </button>
                                </mat-list-item>
                            </mat-list>
                            <!--          <mat-list class="menuList">-->
                            <!--            <mat-list-item class="menuList" >-->
                            <!--              <button mat-menu-item>-->
                            <!--                <mat-icon class="icon">email</mat-icon>&nbsp; Προσθήκη pdf σε email-->
                            <!--              </button>-->
                            <!--            </mat-list-item>-->
                            <!--          </mat-list>-->
                        </mat-menu>
                    </div>
                    <!--      -->
                </div>

                <div fxLayout="row" fxFlex="grow" style="margin-top:5px;" ngStyle.md="width:90%"
                     ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:100%">

                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start" #tableContainer>

                        <div fxLayout="row" fxLayoutAlign="start center center" style="margin-bottom: 10px;"
                             *ngIf="showStudentsMessage">
                            <label><u style="color: red;">*Είναι περίοδος ενημέρωσης χρηστών.
                                Παρακαλούμε αναζητήστε τους χρήστες στις νέες κατηγορίες</u></label>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="flex-end" fxFlex="grow" style="margin-bottom: 10px;">
                            <label><u>Επιλεγμένοι <b>{{selection.selected.length}}</b> χρήστες</u></label>
                        </div>

                        <!--        Table     -->
                        <div fxLayout="row" [style.max-height.px]=" studentsLoading ? 50 : tableHeight">
                            <mat-table [dataSource]="students" matSort style="width:100%; overflow: auto;"
                                       [style.max-height.px]=" studentsLoading ? 50 : tableHeight">

                                <ng-container matColumnDef="select">
                                    <mat-header-cell fxFlex="5" *matHeaderCellDef fxLayoutAlign="start center center">
                                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                                      [checked]="selection.hasValue() && isAllSelected()"
                                                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                                        </mat-checkbox>
                                    </mat-header-cell>
                                    <mat-cell fxFlex="5" *matCellDef="let row" fxLayoutAlign="start center center">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                                      (change)="$event ? selection.toggle(row) : null"
                                                      [checked]="selection.isSelected(row)">
                                        </mat-checkbox>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="lastName">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center">
                                        Επώνυμο
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.lastName}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="firstName">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center"> Όνομα
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.firstName}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="birthday">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center"> Ημ/Γέννησης
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.birthday}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="className">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center"> Τάξη
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.className}} </mat-cell>
                                </ng-container>

                                <!--        External Info-->
                                <ng-container matColumnDef="externalSchoolUnitDescription">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center"> Σχολική μονάδα
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.externalSchoolUnitDescription}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="externalSchoolDescription">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center"> Σχολείο
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.externalSchoolDescription}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="externalClassDescription">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center"> Τάξη
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.externalClassDescription}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="externalClassDepartmentDescription">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center"> Τμήμα
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.externalClassDepartmentDescription}} </mat-cell>
                                </ng-container>

                                <!--        End External Info-->
                                <ng-container matColumnDef="fatherDisplayName">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center">Πατέρας
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.fatherDisplayName}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="father_email">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center"> Email Πατέρα
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.father_email}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="motherDisplayName">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center">Μητέρα
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.motherDisplayName}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="mother_email">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center"> Email Μητέρας
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let student"
                                              fxLayoutAlign="start center center"> {{student.mother_email}} </mat-cell>
                                </ng-container>
                                <mat-header-row class="tableHeaderCell"
                                                *matHeaderRowDef="hasExternalChildren ? columnsToDisplayExternal : columnsToDisplay; sticky: true"></mat-header-row>
                                <mat-row
                                        *matRowDef="let record; columns: hasExternalChildren ? columnsToDisplayExternal : columnsToDisplay"
                                        (click)="selection.toggle(record)"></mat-row>


                            </mat-table>
                        </div>

<!--                        Skeleton Loading-->
                        <div *ngIf="studentsLoading">
                            <app-skeleton-loading></app-skeleton-loading>
                        </div>

                        <div *ngIf="students.data.length === 0 && !studentsLoading" fxLayoutAlign="center center center"
                             style="margin-top:50px; margin-bottom: 50px;">
                            Δεν υπάρχουν χρήστες με αυτά τα κριτήρια
                        </div>
                    </div>

                </div>

                <div fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
                    <mat-paginator [length]="studentsService.students.data.length" [pageSize]="200"
                                   [pageSizeOptions]="[10, 50, 100, 200]">
                    </mat-paginator>
                </div>

            </div>

        </mat-card-content>
    </mat-card>

</div>
